<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <deposito-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import DepositoProvider from "../../../providers/DepositoProvider";
    
    import {CrudUpdate} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    import DepositoForm from "../DepositoForm";
  
    

    export default {
        name: "DepositoUpdate",
        
        components: { DepositoForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'deposito.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                     id: this.item.id,
                    nombre: this.item.nombre,
                    direccion: this.item.direccion,
                    descripcion: this.item.descripcion
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    DepositoProvider.updateDeposito(this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.depositoUpdate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>



